<template>
  <!-- 代理商-对账流水 -->
  <div class="app-content">
    <AppPageTitle></AppPageTitle>
    <Content class="app-content__main">
      <Form ref="formValidate" :model="formValidate" :label-width="120">
        <Row>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="平台订单号:" prop="tradeNo">
              <Input v-model.trim="formValidate.tradeNo" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="代理商订单号:" prop="outTradeNo">
              <Input v-model.trim="formValidate.outTradeNo" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="用户:" prop="account">
              <Input v-model.trim="formValidate.account" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="商品名称:" prop="commodityName">
              <Input v-model.trim="formValidate.commodityName" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="商品编号:" prop="commodityId">
              <Input v-model.trim="formValidate.commodityId" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="代理商:" prop="agentId">
              <Select v-model="formValidate.agentId" clearable style="width: 100%;">
                <Option v-for="item in agentList" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="代理商商品编号:" prop="agentCommodityId">
              <Input v-model.trim="formValidate.agentCommodityId" placeholder="请输入" clearable maxlength="50" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="发券时间:">
              <DatePicker
                type="datetimerange"
                v-model="sendingData"
                format="yyyy-MM-dd HH:mm:ss"
                split-panels
                placeholder="请选择"
                style="width:100%" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="核销时间:">
              <DatePicker
                type="datetimerange"
                v-model="usageData"
                format="yyyy-MM-dd HH:mm:ss"
                split-panels
                placeholder="请选择"
                style="width:100%" />
            </FormItem>
          </Col>
          <Col :md="8" :sm="12" :xs="24">
            <FormItem label="状态:" prop="agentReconciliationStatus">
              <Select v-model="formValidate.agentReconciliationStatus" clearable style="width: 100%;">
                <Option v-for="item in reconciliationStatus" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :md='24' class="text-right">
            <Button type="primary" @click="formSubmit" icon="md-search" style="margin: 0 8px 16px 16px;">查询</Button>
            <Button type="default" @click="formReset" style="margin: 0 0 16px 0;">重置</Button>
          </Col>
        </Row>
      </Form>
      <Row>
        <Col  style="margin-bottom: 20px">
          <Button
            type="info"
            icon="md-download"
            style="margin-right: 8px"
            :disabled="!queryData.length"
            @click="exportOrder"
          >导出</Button>
          <Button
            style="margin-right: 8px"
            :disabled="!selection.length"
            @click="batchChange"
          >批量修改状态</Button>
        </Col>
      </Row>
      <Table
        :columns="queryColumn"
        :loading="loading"
        :data="queryData"
        @on-selection-change="onSelectionChange"
        border
        ref="dataTable"
      >
        <template slot-scope="{row}" slot="reconciliationStatus">
          <OrderStatus :node-state="row.agentReconciliationStatus" :tag-info="reconciliationStatus"></OrderStatus>
        </template>
        <template slot-scope="{row, index}" slot="action">
          <Button
            v-show="row.agentReconciliationStatus !== 3"
            type="text"
            class="text-link"
            size="small"
            icon="md-create"
            @click="updateStatus(row, index)"
          >修改状态</Button>
        </template>
      </Table>
      <Row>
        <Col :md="24" class="pagination">
          <Page
            :total="totalPage"
            :page-size="pageSize"
            :current="pageNum"
            :disabled="loading"
            @on-change="pageChange"
            @on-page-size-change="pageSizeChange"
            show-elevator show-sizer show-total />
        </Col>
      </Row>
    </Content>
    <ExportFile ref="exportFile" />
    <AccountStatus ref="accountStatus" @success="accountStatusUpdateSuccess"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '../../api'
import ExportFile from '../../components/common/ExportFile'
import OrderStatus from '@/components/order/OrderStatus.vue'
import AccountStatus from '@/components/supplier/AccountStatus.vue'

export default {
  components: {
    ExportFile,
    OrderStatus,
    AccountStatus
  },
  data () {
    return {
      formValidate: {
        reconciliationType: 1, // 请求供应商流水标识
        tradeNo: null, // 平台订单号
        outTradeNo: null, // 代理商订单号
        account: null, // 用户
        commodityName: null, // 商品名称
        commodityId: null, // 商品编号
        agentId: null, // 代理商ID
        agentCommodityId: null, // 代理商商品编号
        sendingEndDate: null, // 发券时间开始
        sendingStartDate: null, // 发券时间结束
        usageEndDate: null, // 核销时间开始
        usageStartDate: null, // 核销时间结束
        agentReconciliationStatus: null // 流水状态
      },
      queryData: [],
      selection: [],
      loading: false,
      totalPage: 1,
      pageSize: 10,
      pageNum: 1,
      sendingData: [], // 发券开始结束时间
      usageData: [], // 核销开始结束时间
      supplierList: [], // 供应商下拉
      agentList: [] // 代理商下拉
    }
  },
  computed: {
    ...mapGetters(
      'recharge',
      ['reconciliationStatus']),
    queryColumn () {
      return [
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'center'
        },
        {
          title: '平台订单号',
          key: 'tradeNo',
          align: 'center',
          minWidth: 150
        },
        {
          title: '代理商订单号',
          key: 'outTradeNo',
          align: 'center',
          minWidth: 150
        },
        {
          title: '用户',
          key: 'account',
          align: 'center',
          minWidth: 150
        },
        {
          title: '商品名称',
          key: 'commodityName',
          align: 'center',
          minWidth: 150
        },
        {
          title: '商品编号',
          key: 'commodityId',
          align: 'center',
          minWidth: 150
        },
        {
          title: '代理商',
          key: 'agentName',
          align: 'center',
          minWidth: 150
        },
        {
          title: '代理商商品编号',
          key: 'agentCommodityId',
          align: 'center',
          minWidth: 150
        },
        {
          title: '代理商价格',
          key: 'unitSalePrice',
          minWidth: 130,
          align: 'center'
        },
        {
          title: '发券时间',
          key: 'sendingDateStr',
          align: 'center',
          minWidth: 190
        },
        {
          title: '核销时间',
          key: 'usageDateStr',
          align: 'center',
          minWidth: 190
        },
        {
          title: '状态',
          key: 'agentReconciliationStatus',
          minWidth: 150,
          align: 'center',
          slot: 'reconciliationStatus'
        },
        {
          title: '备注',
          key: 'agentReconciliationNotes',
          align: 'center',
          className: 'remark-column',
          minWidth: 190
        },
        {
          title: '操作',
          key: 'id',
          minWidth: 120,
          slot: 'action',
          align: 'center',
          fixed: 'right'
        }
      ]
    }
  },
  watch: {
    sendingData (val) {
      this.formValidate.sendingStartDate = val[0] ? val[0].getTime() : null
      this.formValidate.sendingEndDate = val[1] ? val[1].getTime() : null
    },
    usageData (val) {
      this.formValidate.usageStartDate = val[0] ? val[0].getTime() : null
      this.formValidate.usageEndDate = val[1] ? val[1].getTime() : null
    }
  },
  methods: {
    formSubmit () {
      this.pageNum = 1
      this.pageSize === 10 ? this.getData() : this.pageSize = 10
    },
    formReset () {
      this.$refs['formValidate'].resetFields()
      this.sendingData.splice(0)
      this.usageData.splice(0)
      this.$nextTick(() => {
        this.formSubmit()
      })
    },
    getData () {
      this.loading = true
      let params = {}
      for (const item in this.formValidate) {
        if (this.formValidate.hasOwnProperty(item)) {
          const element = this.formValidate[item]
          if (element !== '' && element !== null) {
            params[item] = this.formValidate[item]
          }
        }
      }
      params.pageNum = this.pageNum
      params.pageSize = this.pageSize
      api.order.rechargeList({
        ...params
      })
        .then((res) => {
          this.loading = false
          this.totalPage = +res.data.total
          this.queryData = res.data.records.map(record => {
            Object.keys(record).forEach(e => {
              if (record[e] === '1970-01-01 08:00:00')record[e] = ''
            })
            // 如果流水状态为付款完成,则无法修改
            if (record.agentReconciliationStatus === 3) record._disabled = true
            return record
          }) || []
        })
        .catch((err) => {
          this.loading = false
          this.$Message.error('获取订单列表失败: ' + err.message)
        })
    },
    pageChange (pageNum) {
      this.pageNum = pageNum
      this.getData()
    },
    pageSizeChange (pageSize) {
      this.pageSize = pageSize
      this.pageNum === 1 ? this.getData() : this.pageNum = 1
    },
    onSelectionChange (selection) {
      this.selection = selection
    },
    batchChange () {
      this.$refs.accountStatus.show(this.selection, 1)
    },
    updateStatus (row, index) {
      this.$refs.accountStatus.show([row], 1)
    },
    accountStatusUpdateSuccess () {
      this.getData()
    },
    // 导出
    exportOrder () {
      let params = {}
      for (const item in this.formValidate) {
        if (this.formValidate.hasOwnProperty(item)) {
          if (this.formValidate[item] !== '' && this.formValidate[item] !== null) {
            params[item] = this.formValidate[item]
          }
        }
      }
      params.pageNum = 1
      params.pageSize = 10
      this.$refs.exportFile.submit(api.agent.outQueryAgentFlow, 'get', {
        ...params
      })
    }
  },
  created () {
    this.getData()
    // 获取代理商数据改造成下拉数据
    api.agent.agentList({
      pageNum: 1,
      pageSize: 100
    })
      .then((res) => {
        this.agentList = res.data.records
          .map(item => ({
            value: item.id,
            label: item.agentName
          })) || []
      })
      .catch((err) => {
        this.$Message.error('获取代理商列表失败: ' + err.message)
      })
  }
}
</script>
<style lang="less">
.ivu-table td.remark-column{
  .ivu-table-cell{
    white-space: pre-wrap
  }
}
</style>
